var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.338,
    height: 41.134,
    viewBox: "0 0 60.338 41.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.678,863.31a5.571,5.571,0,0,0-3.932,1.622,5.459,5.459,0,0,0,0,7.814,5.593,5.593,0,0,0,3.932,1.622,5.529,5.529,0,0,0,0-11.058Zm0,8.6a3.072,3.072,0,1,1,0-6.143,3.072,3.072,0,0,1,0,6.143Z",
    transform: "translate(-312.349 -833.233)",
    fill: "#0f192d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.455,711.129a1.194,1.194,0,0,0-.823-.319h-6.3a1.232,1.232,0,0,0-1.229,1.229v10.075a1.232,1.232,0,0,0,1.229,1.229h10a1.232,1.232,0,0,0,1.229-1.229v-6.745a1.229,1.229,0,0,0-.405-.909Zm1.646,9.755h-7.544v-7.63h4.6l2.949,2.654Z",
    transform: "translate(-302.7 -699.47)",
    fill: "#0f192d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.478,863.31a5.571,5.571,0,0,0-3.932,1.622,5.459,5.459,0,0,0,0,7.814,5.593,5.593,0,0,0,3.932,1.622,5.529,5.529,0,0,0,0-11.058Zm0,8.6a3.072,3.072,0,1,1,0-6.143,3.072,3.072,0,0,1,0,6.143Z",
    transform: "translate(-98.152 -833.233)",
    fill: "#0f192d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.427,843.507h-2.47v-3.268a1.229,1.229,0,1,0-2.457,0v4.5a1.232,1.232,0,0,0,1.229,1.229h3.7a1.229,1.229,0,1,0,0-2.457Z",
    transform: "translate(-44.295 -811.919)",
    fill: "#0f192d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.36,812.339a1.232,1.232,0,0,0-1.229-1.229H1.229a1.229,1.229,0,0,0,0,2.457h14.9A1.224,1.224,0,0,0,17.36,812.339Z",
    transform: "translate(0 -787.447)",
    fill: "#0f192d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.615,767.467l14.9.086a1.24,1.24,0,0,0,1.241-1.216,1.217,1.217,0,0,0-1.216-1.241l-14.9-.086h-.012a1.229,1.229,0,0,0-.012,2.457Z",
    transform: "translate(-17.892 -747.011)",
    fill: "#0f192d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.929,722.067h14.9a1.229,1.229,0,0,0,0-2.457h-14.9a1.229,1.229,0,0,0,0,2.457Z",
    transform: "translate(-35.7 -707.189)",
    fill: "#0f192d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.179,631.73h0l-8.8-7.286a1.21,1.21,0,0,0-.786-.283H84.25v-4.423a1.232,1.232,0,0,0-1.229-1.229H51.729a1.232,1.232,0,0,0-1.229,1.229v8.994a1.229,1.229,0,1,0,2.457,0v-7.765H81.805V650.1H71.731a1.229,1.229,0,0,0,0,2.457h15a1.229,1.229,0,0,0,0-2.457h-2.47V626.619h9.9l8.011,6.635-.086,16.82h-1.278a1.229,1.229,0,1,0,0,2.457h2.494a1.222,1.222,0,0,0,1.229-1.216l.1-18.626A1.3,1.3,0,0,0,104.179,631.73Z",
    transform: "translate(-44.295 -618.51)",
    fill: "#0f192d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvios);
export default __webpack_public_path__ + "static/media/envios.8392cb23189c5e620c4db0096e92b69d.svg";
export { ForwardRef as ReactComponent };